import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { createContext, useContext, useState, ReactNode } from 'react';

interface SupportTokenContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const SupportTokenContext = createContext<SupportTokenContextType | undefined>(undefined);

export function SupportTokenProvider({ children }: { children: ReactNode }) {
  useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SupportTokenContext.Provider
      value={{
        isOpen,
        openModal: () => setIsOpen(true),
        closeModal: () => setIsOpen(false),
      }}
    >
      {children}
    </SupportTokenContext.Provider>
  );
}

export function useSupportTokenModal() {
  useLanguage();
  const context = useContext(SupportTokenContext);
  if (!context) {
    throw new Error(translateInterfaceText("useSupportTokenModal must be used within SupportTokenProvider"));
  }
  return context;
}
